import React from "react";
import { useParams } from "react-router-dom";

/**
 * Bounces /go/<slug> on the player-facing host to the backend that serves it.
 *
 * /go/<slug> is a Django route, but the player-facing host proxies everything
 * to the React dev/prod server, so the request never reaches Django and the SPA
 * answers with its own shell — a blank page. The proper fix is one proxy rule
 * on the edge (see docs/deployment-strategy.md), but that is a server change,
 * and this needs none: React owns the route, and the first thing it does is
 * hand the browser to the origin that can actually serve it.
 *
 * The backend then 302s straight back to /launch-entry on this host, so the
 * player sees one extra hop and nothing else. Costs a round trip; keeps
 * capture.playticket.us/go/<slug> as the public URL with no edge config.
 *
 * The identity cookie lands on whichever origin serves /go/, and that is
 * consistent either way: /go/remember posts to the same REACT_APP_WEB_ORIGIN,
 * so the cookie is written and read on one host. SameSite=Lax still allows it
 * on the top-level GET navigation that /go/<slug> is.
 */
const WEB_ORIGIN =
    process.env.REACT_APP_WEB_ORIGIN || process.env.REACT_APP_API_URL || "";

function WebLaunchRedirect(){
    const { slug } = useParams();

    React.useEffect(() => {
        if (!slug) return;
        // No origin configured means /go/ is served from this host already, in
        // which case React should never have seen this route — bail rather than
        // redirect to ourselves and loop.
        if (!WEB_ORIGIN) return;
        window.location.replace(WEB_ORIGIN + "/go/" + encodeURIComponent(slug));
    }, [slug]);

    return (
        <div style={{
            fontFamily: "-apple-system, system-ui, sans-serif",
            background: "#111", color: "#eee",
            display: "flex", alignItems: "center", justifyContent: "center",
            minHeight: "100vh", margin: 0
        }}>
            <p>Loading…</p>
        </div>
    );
}

export default WebLaunchRedirect;
